import { render, staticRenderFns } from "./RuleOverview.vue?vue&type=template&id=033f60b9&scoped=true"
import script from "./RuleOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./RuleOverview.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RuleOverview.vue?vue&type=style&index=0&id=033f60b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033f60b9",
  null
  
)

export default component.exports